module.exports = __webpack_public_path__ + "static/media/icon-x-wht.e8d7c4e2.svg";